// extracted by mini-css-extract-plugin
module.exports = {"container":"NFTFearGreedIndex_container__RG5Gw","indexImage":"NFTFearGreedIndex_indexImage__1pIJ2"};